(function(){
  var form = document.querySelector('form[action="/cart/add"]');
  if (!form) {
    console.error('Unable to find add to cart form element for customizer');
    return;
  }
  var button = form.querySelector('button[type="submit"]');
  if (!button) {
    console.error('Unable to find add to cart form for customizer');
    return;
  }
  button.innerHTML = 'Customize'
  button.addEventListener("click", function (e) {
    e.preventDefault();
    var variantId = document.querySelector('form[action="/cart/add"] select[name=id]').value;
    if (!variantId) {
      console.error('Unable to find variant ID to customize in cart form');
      return;
    }
    console.log('redirecting to', variantId);
    window.location.href = "/apps/product-editor/" + variantId;
  });
})();